export default {
  container: {
    position: 'fixed',
    height: '100vh',
    width: '100%',
    opacity: '0',
    '@media print': {
      position: 'static',
      opacity: '1'
    }
  },
  test: {
    opacity: '1',
    position: 'static'
  },
  slideHolder: {
    '@media print': {
      position: 'relative',
      height: '100%',
      border: '1px solid #999',
      borderRadius: '10px',
      overflow: 'hidden'
    }
  },
  slideContainer: {
    '@media print': {
      boxSizing: 'border-box',
      '-webkit-print-color-adjust': 'exact',
      height: '100%',
      padding: '40px'
    }
  }
}
